<template>
  <v-container fluid>
    <page-header showBackButton>
      <template slot="botRightSlot">
        <v-btn
          depressed
          class="ml-2 mb-4"
          elevation="0"
          color="primary"
          :disabled="$store.getters.isLoading"
          :to="{ name: 'UserDetail', params: { id: formData.user_id } }"
          >{{ $t('viewAccount') }}</v-btn
        >

        <v-btn
          v-if="staticData.payment_status === 'paid' && staticData.receipt"
          depressed
          class="ml-2 mb-4"
          elevation="0"
          color="primary"
          :disabled="$store.getters.isLoading"
          target="_blank"
          :download="receiptName"
          :href="`${$mediaPath}${staticData.receipt}`"
          >{{ $t('downloadReceipt') }}</v-btn
        >
      </template>
    </page-header>

    <v-card class="mb-4">
      <v-card-text>
        <v-form ref="basicForm" @submit.prevent>
          <v-row class="ma-0">
            <v-col cols="12" sm="6" lg="3">
              <label class="text-subtitle-2 mb-2 d-block colorGrey--text">{{ $t('orderDateTime') }}</label>
              <div class="colorBlack--text">{{ $Formatter.displayCreateDate(formData.create_date) }}</div>
            </v-col>
            <v-col cols="12" sm="6" lg="3">
              <label class="text-subtitle-2 mb-2 d-block colorGrey--text">{{ $t('orderId') }}</label>
              <div class="colorBlack--text">
                {{ $Formatter.getOrderId({ id: id, create_date: formData.create_date }) }}
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3">
              <label class="text-subtitle-2 mb-2 d-block colorGrey--text">{{ $t('companyType') }}</label>
              <div class="colorBlack--text" v-if="formData.company_type">
                {{ $t('companyTypeOption.' + formData.company_type) }}
              </div>
              <div class="colorBlack--text" v-else>-</div>
            </v-col>
            <v-col cols="12" sm="6" lg="3">
              <label class="text-subtitle-2 mb-2 d-block colorGrey--text">{{ $t('companyNameEn') }}</label>
              <div class="colorBlack--text">{{ formData.company_name_en }}</div>
            </v-col>
            <v-col cols="12" sm="6" lg="3">
              <label class="text-subtitle-2 mb-2 d-block colorGrey--text">{{ $t('companyNameZh') }}</label>
              <div class="colorBlack--text">{{ formData.company_name_zh }}</div>
            </v-col>
            <v-col cols="12" sm="6" lg="3">
              <label class="text-subtitle-2 mb-2 d-block colorGrey--text">{{ $t('paymentMethod') }}</label>
              <div class="colorBlack--text">
                {{ formData.payment_method ? $t(`paymentMethodOptions.${formData.payment_method}`) : '-' }}
              </div>
            </v-col>
            <v-col cols="12" sm="6" lg="3" v-if="formData.payment_method === 'transfer'">
              <v-btn
                x-large
                elevation="0"
                color="primary"
                :disabled="!formData.payment_file"
                target="_blank"
                :href="`${$mediaPath}${formData.payment_file}`"
                >{{ $t('viewPaymentFile') }}</v-btn
              >
            </v-col>
            <v-col cols="12" sm="6" lg="3">
              <form-select
                label="status"
                :fieldValue.sync="formData.payment_status"
                :options="paymentStatusOptions"
                required
              />
            </v-col>
          </v-row>

          <v-btn
            depressed
            elevation="0"
            class="ml-2 mb-4"
            color="primary"
            type="button"
            @click="save()"
            :loading="$store.getters.isLoading"
            >{{ $t('save') }}</v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>

    <v-card class="mb-8">
      <v-card-text>
        <v-row class="ma-0">
          <v-col cols="12">
            <h4 class="section-title">{{ $t('service') }}</h4>
          </v-col>

          <v-col cols="12">
            <datatable
              :tableHeaders="tableHeaders"
              :tableData="tableData"
              disableToolbar
              disablePagination
              disableShadow
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import FormSelect from '@/components/form/FormSelect.vue'
import Datatable from '@/components/Datatable.vue'
export default {
  name: 'OrderDetail',
  components: {
    FormSelect,
    Datatable,
  },
  computed: {
    id() {
      const id = parseInt(this.$route.params.id)
      if (!isNaN(id)) {
        return id
      }

      return null
    },
    receiptName() {
      if (this.staticData.receipt) {
        let name = this.staticData.receipt.split('.')[0]
        name = name.split('_').pop()
        return name
      }
      return ''
    },
  },
  data: vm => ({
    staticData: {
      payment_status: '',
      receipt: '',
    },
    formData: {
      user_id: -1,
      create_date: '',

      company_type: '',
      company_name_en: '',
      company_name_zh: '',
      payment_method: '',
      payment_file: '',
      payment_status: '',
      payment_id: -1,
    },

    tableData: [],
    tableHeaders: [
      { value: 'service', text: vm.$t('service') },
      { value: 'price', text: vm.$t('price'), align: 'end', prefix: 'HK$' },
    ],

    paymentStatusOptions: [
      { value: 'paid', text: vm.$t('paymentStatusOptions.paid') },
      { value: 'pending', text: vm.$t('paymentStatusOptions.pending') },
      { value: 'unpaid', text: vm.$t('paymentStatusOptions.unpaid') },
    ],
  }),
  methods: {
    async getOrder() {
      try {
        const data = await this.$Fetcher.GetOrderById(this.id)
        for (let key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.formData[key] = data[key]
          }
        }

        this.staticData.receipt = data.receipt

        if (data.plan_data_list) {
          data.plan_data_list.forEach(item => {
            let price = item.price

            if (data.order_type === 'override') {
              const datetime = this.$Formatter.convertStrToDate(data.end_date)
              const scale_start = new Date(datetime.getFullYear() - 1, datetime.getMonth(), datetime.getDate())
              const active_days = this.$Formatter.getDaysDiff(
                datetime,
                this.$Formatter.convertStrToDate(data.start_date),
              )
              const total_days = this.$Formatter.getDaysDiff(datetime, scale_start)
              const scale = active_days / total_days
              price = Math.ceil(item.price * scale * 10) / 10
            }

            this.tableData.push({
              service: this.$Formatter.getServiceName(item.name_zh, this.$t(`planTypeOption.${item.type}`)),
              price: price,
            })

            if (item.government_charge > 0) {
              this.tableData.push({
                service: this.$t('govFee'),
                price: item.government_charge,
              })
            }
          })
        }

        if (data.addon_data_list) {
          data.addon_data_list.forEach(item => {
            this.tableData.push({
              service: this.$Formatter.getServiceName(item.name_zh),
              price: item.price,
            })
          })
        }

        await this.getCompany(data.company_id)
        await this.getUpdatedPaymentData()
      } catch (err) {
        this.$common.error(err)
        this.$store.dispatch('setAlert', {
          message: 'noData',
          redirect: 'OrderList',
        })
      } finally {
        this.$store.dispatch('setInitLoading', false)
      }
    },
    async getCompany(id) {
      try {
        const data = await this.$Fetcher.GetCompanyById(id)
        this.formData.company_type = data.type
        this.formData.company_name_zh = data.name_zh
        this.formData.company_name_en = data.name_en
      } catch {}
    },
    async getUpdatedPaymentData() {
      try {
        const data = await this.$Fetcher.GetPaymentById(this.formData.payment_id)
        if (data.payment_method === 'transfer' && data.payment_data) {
          if (data.payment_data.indexOf('"') > -1) {
            this.formData.payment_file = JSON.parse(data.payment_data)
          } else {
            this.formData.payment_file = data.payment_data
          }
        }
        this.formData.payment_status = data.status
        this.staticData.payment_status = data.status
      } catch {}
    },

    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', {
          message: 'processing',
        })
        return
      }

      const valid = await this.$refs['basicForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', {
          message: 'required',
        })
        return
      }

      this.$store.dispatch('setLoading', true)

      try {
        await this.$Fetcher.UpdateOrderPayment(this.formData.payment_id, {
          status: this.formData.payment_status,
        })
        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('setLoading', false)
        this.$store.dispatch('toggleSnack', {
          type: 'success',
          message: 'message.saveSuccess',
          refresh: true,
        })
      } catch (err) {
        this.$common.error(err)
        this.$store.dispatch('setLoading', false)
        this.$store.dispatch('setAlert', {
          title: 'message.saveFail',
          message: err,
          type: 'error',
        })
      }
    },
  },

  async mounted() {
    this.$store.dispatch('setInitLoading', true)
    if (this.$validate.DataValid(this.id)) {
      // edit
      this.getOrder()
    } else {
      this.$store.dispatch('setInitLoading', false)
      this.$store.dispatch('setAlert', {
        message: 'noData',
        redirect: 'OrderList',
      })
    }
  },
}
</script>
